import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './about-us.css'

const AboutUs = (props) => {
  return (
    <div className="about-us-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="About-Us - Well Off Notable Fish" />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/about-us"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="about-us-hero-section">
        <div className="hero-media-wrapper">
          <img
            alt="A woman with binary code lights projected on her face, symbolizing technology."
            src="https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="about-us-hero-content-wrapper">
          <div className="about-us-hero-content-inner">
            <h1 className="hero-title about-us-hero-title">
              Securing Digital Infrastructure with Uncompromising Expertise
            </h1>
            <p className="about-us-hero-subtitle hero-subtitle">
              Cysigil Network is a cybersecurity consulting firm dedicated to
              protecting enterprises against evolving threats through
              comprehensive security services, compliance advisory, and
              cutting-edge threat intelligence.
            </p>
            <div className="hero-credential-grid">
              <div className="hero-credential-item">
                <div className="hero-credential-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <span className="hero-credential-text">
                  ISO 27001 Certified
                </span>
              </div>
              <div className="hero-credential-item">
                <div className="hero-credential-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <span className="hero-credential-text">
                  SOC 2 Type II Compliant
                </span>
              </div>
              <div className="hero-credential-item">
                <div className="hero-credential-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                      <circle r="6" cx="12" cy="8"></circle>
                    </g>
                  </svg>
                </div>
                <span className="hero-credential-text">PCI-DSS Qualified</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-content-grid">
            <div className="mission-text-column">
              <div className="mission-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h2 className="mission-title section-title">Our Mission</h2>
              <p className="section-content mission-description">
                To empower organizations with world-class cybersecurity
                solutions that protect critical assets, ensure regulatory
                compliance, and build resilient defenses against sophisticated
                cyber threats. We are committed to delivering excellence through
                continuous innovation, rigorous testing, and strategic advisory
                that meets the highest industry standards.
              </p>
              <ul className="mission-value-list">
                <li className="mission-value-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Uncompromising Security Standards</span>
                </li>
                <li className="mission-value-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Proactive Threat Intelligence</span>
                </li>
                <li className="mission-value-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Client-Centric Approach</span>
                </li>
              </ul>
            </div>
            <div className="mission-visual-column">
              <div className="mission-vision-card">
                <div className="mission-vision-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="mission-vision-title">Our Vision</h3>
                <p className="mission-vision-text">
                  To be the most trusted cybersecurity partner globally,
                  recognized for pioneering security methodologies, AI-driven
                  threat detection, and setting new benchmarks in operational
                  resilience and governance.
                </p>
              </div>
              <div className="mission-stats-wrapper">
                <div className="mission-stat-item">
                  <div className="mission-stat-number">
                    <span>15+</span>
                  </div>
                  <div className="mission-stat-label">
                    <span>Year of Experince team</span>
                  </div>
                </div>
                <div className="mission-stat-item">
                  <div className="mission-stat-number">
                    <span>50+</span>
                  </div>
                  <div className="mission-stat-label">
                    <span>Clients Protected</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-us-certifications-section">
        <div className="certifications-container">
          <div className="about-us-certifications-header">
            <h2 className="certifications-title section-title">
              Industry Certifications &amp; Affiliations
            </h2>
            <p className="section-subtitle certifications-subtitle">
              Our commitment to excellence is validated by leading industry
              certifications and memberships in premier cybersecurity
              organizations worldwide.
            </p>
          </div>
          <div className="certifications-grid">
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">
                ISO 27001 Certified
              </h3>
              <p className="certification-description">
                Information Security Management System certification
                demonstrating our commitment to security best practices.
              </p>
            </div>
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">SOC 2 Type II</h3>
              <p className="certification-description">
                Third-party attestation of our security controls, availability,
                and confidentiality standards over extended periods.
              </p>
            </div>
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">PCI-DSS</h3>
              <p className="certification-description">
                Qualified Security Assessor status enabling us to conduct
                payment card industry compliance assessments.
              </p>
            </div>
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">CREST Accredited</h3>
              <p className="certification-description">
                International accreditation for penetration testing and cyber
                incident response capabilities.
              </p>
            </div>
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">NIST Framework</h3>
              <p className="certification-description">
                Adherence to National Institute of Standards and Technology
                cybersecurity framework for risk management.
              </p>
            </div>
            <div className="about-us-certification-card">
              <div className="certification-logo-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-us-certification-name">(ISC)² Member</h3>
              <p className="certification-description">
                Active membership in the world&apos;s leading organization for
                certified cybersecurity professionals.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="culture-section">
        <div className="culture-wrapper">
          <div className="culture-header-container">
            <h2 className="culture-title section-title">
              Our Culture &amp; Values
            </h2>
            <p className="section-subtitle culture-subtitle">
              We believe that exceptional cybersecurity starts with exceptional
              people. Join a team that values innovation, integrity, and
              continuous learning.
            </p>
          </div>
          <div className="culture-columns">
            <div className="culture-column">
              <div className="culture-icon-container">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="culture-column-title">Integrity First</h3>
              <p className="culture-column-text">
                We operate with unwavering ethical standards, transparency, and
                accountability in every client engagement and internal decision.
                Trust is our foundation, and we earn it through consistent
                actions and honest communication.
              </p>
              <ul className="culture-benefit-list">
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Ethical hacking principles</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Transparent reporting</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Confidentiality guaranteed</span>
                </li>
              </ul>
            </div>
            <div className="culture-column">
              <div className="culture-icon-container">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 11l4-4l4 4m-4 5V7M2 16l4.039-9.69a.5.5 0 0 1 .923 0L11 16m-7.696-3h6.392"></path>
                  </g>
                </svg>
              </div>
              <h3 className="culture-column-title">Continuous Innovation</h3>
              <p className="culture-column-text">
                We invest heavily in research, emerging technologies, and
                cutting-edge methodologies to stay ahead of evolving threats.
                Our team actively contributes to open-source security tools and
                participates in global security conferences.
              </p>
              <ul className="culture-benefit-list">
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Annual training budget</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Conference attendance</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Certification support</span>
                </li>
              </ul>
            </div>
            <div className="culture-column">
              <div className="culture-icon-container">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="culture-column-title">Team Excellence</h3>
              <p className="culture-column-text">
                We foster a collaborative environment where diverse perspectives
                drive innovation and every team member is empowered to
                contribute their unique expertise. Work-life balance and
                professional growth are core priorities.
              </p>
              <ul className="culture-benefit-list">
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Flexible work arrangements</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Mentorship programs</span>
                </li>
                <li className="culture-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Career advancement paths</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="culture-careers-banner">
            <div className="culture-careers-content">
              <h3 className="culture-careers-title">Join Our Team</h3>
              <p className="culture-careers-text">
                We&apos;re always looking for talented cybersecurity
                professionals who are passionate about protecting organizations
                and advancing the field.
              </p>
            </div>
            <a href="/careers">
              <div className="culture-careers-button btn-primary btn">
                <span>View Open Positions</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="about-us-casestudies-section">
        <div className="about-us-casestudies-wrapper">
          <div className="about-us-casestudies-header">
            <h2 className="casestudies-title section-title">
              Client Success Stories
            </h2>
            <p className="section-subtitle casestudies-subtitle">
              Real-world engagements demonstrating measurable impact and
              exceptional outcomes across diverse industries and security
              challenges.
            </p>
          </div>
          <div className="about-us-casestudies-grid">
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Overhead view of a diverse team in a business meeting using laptops and tablets."
                  src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>Financial Services</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  {' '}
                  SOC Modernization for Fintech
                </h3>
                <p className="casestudy-description">
                  Optimized security log ingestion, normalization, and
                  correlation across the SOC, reducing noise by 65% and
                  improving incident detection and response efficiency.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">40%</span>
                    <span className="casestudy-metric-label">
                      Cost reduction
                    </span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">99.9%</span>
                    <span className="casestudy-metric-label">Uptime</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Business professionals discussing data charts and graphs in a modern office setting."
                  src="https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>Healthcare</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  Healthcare Provider HIPAA Compliance
                </h3>
                <p className="casestudy-description">
                  Conducted comprehensive security assessment for a regional
                  healthcare network, identified 142 critical vulnerabilities,
                  and implemented remediation roadmap ensuring full HIPAA and
                  HITRUST compliance within 6 months.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">142</span>
                    <span className="casestudy-metric-label">
                      Issues Resolved
                    </span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">100%</span>
                    <span className="casestudy-metric-label">Compliance</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Diverse team collaborating in a meeting, showcasing teamwork and cooperation in a modern workplace."
                  src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>Telecommunication</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  Cloud Telephony Platform
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </h3>
                <p className="casestudy-description">
                  security operations implementing 24/7 SOC-as-a-Service with
                  AI-driven threat detection, reducing incident response time by
                  98% and achieving SOC 2 Type II certification.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">78%</span>
                    <span className="casestudy-metric-label">
                      Faster Response
                    </span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">99.9%</span>
                    <span className="casestudy-metric-label">Uptime</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Businesswoman presenting data on a large digital screen in a modern office setting."
                  src="https://images.pexels.com/photos/5716042/pexels-photo-5716042.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>Manufacturing</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  Industrial OT Security Assessment
                </h3>
                <p className="casestudy-description">
                  Performed advanced OT/ICS security assessment for
                  manufacturing facility with critical infrastructure,
                  identified air-gapped network vulnerabilities, and deployed
                  segmentation strategy preventing potential ransomware attacks.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">35</span>
                    <span className="casestudy-metric-label">
                      Critical Risks
                    </span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">Zero</span>
                    <span className="casestudy-metric-label">Downtime</span>
                  </div>
                </div>
              </div>
            </article>
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Team analyzing financial charts and digital reports during a business meeting."
                  src="https://images.pexels.com/photos/5716032/pexels-photo-5716032.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>SaaS</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  Cloud-Native Application Security
                </h3>
                <p className="casestudy-description">
                  Integrated DevSecOps pipeline for fast-scaling SaaS startup,
                  implementing automated SAST/DAST scanning, container security,
                  and achieving SOC 2 Type II certification to close enterprise
                  deals.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">90%</span>
                    <span className="casestudy-metric-label">
                      Automation Rate
                    </span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">3x</span>
                    <span className="casestudy-metric-label">
                      Faster Deployment
                    </span>
                  </div>
                </div>
              </div>
            </article>
            <article className="about-us-casestudy-card">
              <div className="casestudy-image-container">
                <img
                  alt="Diverse professionals collaborating in a modern office space, focused on teamwork and project management."
                  src="https://images.pexels.com/photos/7438104/pexels-photo-7438104.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="about-us-casestudy-image"
                />
                <div className="casestudy-category-badge">
                  <span>Government</span>
                </div>
              </div>
              <div className="about-us-casestudy-content">
                <h3 className="about-us-casestudy-title">
                  VAPT for Government application 
                </h3>
                <p className="casestudy-description">
                  Performed in-depth VAPT using adversary-emulation techniques
                  to identify exploitable attack paths, validate impact, and
                  guide secure configuration and hardening measures.
                </p>
                <div className="about-us-casestudy-metrics">
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">20</span>
                    <span className="casestudy-metric-label">Application</span>
                  </div>
                  <div className="about-us-casestudy-metric">
                    <span className="casestudy-metric-value">200+</span>
                    <span className="casestudy-metric-label">Fiinding</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div className="casestudies-cta-container">
            <div className="btn-primary btn">
              <span>View All Case Studies</span>
            </div>
          </div>
        </div>
      </section>
      <section className="about-us-cta-section">
        <div className="cta-wrapper">
          <div className="cta-content-grid">
            <div className="cta-text-column">
              <h2 className="about-us-cta-title section-title">
                Ready to Elevate Your Security Posture?
              </h2>
              <p className="section-content about-us-cta-description">
                Partner with cybersecurity experts who understand the critical
                importance of protecting your digital assets. Schedule a
                consultation with our team to discuss your unique security
                challenges and discover tailored solutions.
              </p>
              <ul className="cta-benefits-list">
                <li className="cta-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>Complimentary security assessment</span>
                </li>
                <li className="cta-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>Custom security roadmap</span>
                </li>
                <li className="cta-benefit-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                  <span>24/7 support availability</span>
                </li>
              </ul>
            </div>
            <div className="about-us-thq-cta-action-column-elm cta-action-column">
              <div className="cta-action-card">
                <div className="cta-action-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <circle r="4" cx="9" cy="7"></circle>
                    </g>
                  </svg>
                </div>
                <a className="btn-primary btn btn-lg" href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled">
                  <span>Talk to an Expert</span>
                </a>
                <p className="cta-action-description">
                  Schedule a call with our senior security consultants to
                  discuss your specific requirements.
                </p>
                <a href="/contact-us">
                  <div className="btn-primary btn cta-primary-button">
                    <span>Book Consultation</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="about-us-container2">
        <div className="about-us-container3">
          <Script
            html={`<style>
        @keyframes slideUp {from {opacity: 0;
transform: translateY(20px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="about-us-container4">
        <div className="about-us-container5">
          <Script
            html={`<script defer data-name="about-page-animations">
(function(){
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  const fadeElements = document.querySelectorAll(".team-member-card, .competency-card, .certification-card, .casestudy-card")
  fadeElements.forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "opacity 0.5s ease, transform 0.5s ease"
    fadeInObserver.observe(el)
  })

  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")
  if (mediaQuery.matches) {
    fadeElements.forEach((el) => {
      el.style.transition = "none"
      el.style.opacity = "1"
      el.style.transform = "translateY(0)"
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AboutUs
